"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Stripe_1 = require("./Stripe");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var stripeStyles_1 = require("./stripeStyles");
var react_intl_1 = require("react-intl");
var FailedPaymentError_1 = require("../../ErrorPages/FailedPaymentError");
var TransactionErrorTypes_1 = require("../../../../../../common/enum/TransactionErrorTypes");
var StripeContainer = function (_a) {
    var deal = _a.deal;
    var styles = stripeStyles_1.default();
    var intl = react_intl_1.useIntl();
    var status = deal.status;
    var isStatusFailedOrCancelled = status === TransactionErrorTypes_1.TransactionErrorTypes.FAILED || status === TransactionErrorTypes_1.TransactionErrorTypes.CANCELLED;
    return (<core_1.Box>
      {isStatusFailedOrCancelled ? (<FailedPaymentError_1.default />) : (<>
          <core_1.Typography variant="subtitle1" className={styles.title}>
            <Translation_1.default id="trans__checkout__payment_page__subtitle"/>
          </core_1.Typography>
          <core_1.Typography variant="subtitle2">
            <Translation_1.default className={styles.description} id="trans__checkout__payment_page__description1"/>
          </core_1.Typography>
          <core_1.Typography variant="subtitle1" className={styles.description2}>
            <Translation_1.default id="trans__checkout__payment_page__description2" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__payment_page__email',
        })}>
                    <Translation_1.default id={'trans__checkout__payment_page__email'}/>
                  </a>),
    }}/>
          </core_1.Typography>
        </>)}
      <Stripe_1.default dealStatus={status}/>
    </core_1.Box>);
};
exports.default = StripeContainer;
